import React from 'react'
import { Link } from 'react-router-dom'

function Navigation() {

    const Mailto = ({ email, subject = '', body = '', children }) => {
        let params = subject || body ? '?' : '';
        if (subject) params += `subject=${encodeURIComponent(subject)}`;
        if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

        return <a href={`mailto:${email}${params}`}>{children}</a>;
      };


    return (
        <div
            style={{
                padding: "10px",
                display: "flex",
            }}
        >
            <nav
                style={{
                    fontSize: "20px",
                    display: "flex",
                }}
            >
                <Link exact={true} to="/">/home</Link>
                <Link to="/About">/about</Link>
                <Mailto
                    email="contact@corey-calhoun.com"
                    subject="I am looking for a developer..."
                    body=""
                >
                    /contact
                </Mailto>

            </nav>
        </div>

    )
}

export default Navigation
